import { MANTIS, RED, YELLOW, BLUE } from '../constants'

export const recognizeColor = system => {
  if (system && system.required) {
    return RED
  } else if (system && system.recommended) {
    return MANTIS
  } else if (system && system.custom) {
    return BLUE
  }
  return YELLOW
}

export const recognizeText = (system, t) => {
  if (system && system.required) {
    return t('required')
  } else if (system && system.recommended) {
    return t('recommended')
  } else if (system && system.custom) {
    return t('custom')
  }
  return t('optional')
}

export const getText = (text, t) => {
  if (text) {
    return text
  }
  return t('not_available')
}
